<template>
  <div class="container">
    <home-title
      title="在线设计"
      link="https://lib.yiihuu.com/sc/"
      :icon="require('@/assets/images/home/home_title/icon9.svg')"
    ></home-title>
    <div class="design_box">
      <ul class="ckt_screen">
        <li
          :class="e.kid == stairNum ? 'ta3 active' : 'ta3'"
          v-for="e in stairList"
          :key="e.kid"
          @click="cutStair(e.kid)"
        >
          {{ e.kname }}
        </li>
      </ul>
      <div class="ckt_box">
        <div
          class="ckt_item"
          v-for="e in designList"
          :key="e.designTemplateId"
          @click="goCkt"
        >
          <div class="img_box">
            <div class="img_box_n">
              <img :src="e.designTemplateImageUrl" alt="" />
            </div>
          </div>

          <p class="ckt_title toh">
            {{ e.templateTitle }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeTitle from "./components/homeTitle";
import { getIndexOnlinedsn } from "@/api/home";
export default {
  name: "onlineDesign",
  components: { homeTitle },
  data() {
    return {
      stairList: [],
      designList: [],
      stairNum: 1,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      getIndexOnlinedsn({ f: this.stairNum, pr: 2 }).then((res) => {
        this.stairList = res.data.first_kind_list;
        res.data.data.body.data.queryDesignTemplateBeanList.splice(10);
        this.designList = res.data.data.body.data.queryDesignTemplateBeanList;
      });
    },
    cutStair(kid) {
      this.stairNum = kid;
      this.getList();
    },
    goCkt() {
      location.href = "https://lib.yiihuu.com/sc/";
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 50px;
  .design_box {
    .ckt_screen {
      display: flex;
      li {
        width: 76px;
        height: 30px;
        border: 1px solid #ddd;
        border-radius: 15px;
        text-align: center;
        line-height: 30px;
        font-size: 14px;
        color: #999;
        cursor: pointer;
        margin-right: 16px;
        :last-child {
          margin-right: 0;
        }
        &:hover {
          border-color: #22b79e;
          color: #22b79e;
        }
      }
      .active {
        border-color: #22b79e;
        color: #22b79e;
      }
    }
    .ckt_box {
      display: flex;
      flex-wrap: wrap;
      margin-top: 24px;
      .ckt_item {
        width: 260px;
        height: 220px;
        box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        cursor: pointer;
        margin: 0 20px 24px 0;
        &:nth-child(5n) {
          margin-right: 0;
        }
        .img_box {
          width: 100%;
          height: 172px;
          overflow: hidden;
          border-radius: 10px 10px 0 0;
          line-height: 172px;
          &:hover {
            overflow: visible;
            .img_box_n {
              transition: all 0.3s;
              transform: scale(1.1);
              border: 6px solid #fff;
              box-shadow: 0px 0px 15px 0px #d9d9d9;
              border-radius: 8px;
              background-color: #fff;
              img {
                z-index: 100;
              }
            }
          }
          .img_box_n {
            background-color: #f1f1f1;
            width: 100%;
            border: 0 solid #fff;
            img {
              width: 100%;
              background: #c1c1c1;
              vertical-align: middle;
            }
          }
          img {
            background: #c1c1c1;
          }
        }

        .ckt_title {
          margin: 14px 16px 0;
          font-size: 14px;
          line-height: 21px;
          color: #333;
        }
      }
    }
  }
}
@media screen and (max-width: 1500px) and (min-width: 270px) {
  .container {
    .design_box {
      .ckt_box {
        .ckt_item {
          &:nth-child(5n) {
            margin-right: 20px;
          }
          &:nth-child(4n) {
            margin-right: 0;
          }
          &:nth-child(9) {
            display: none;
          }
          &:nth-child(10) {
            display: none;
          }
        }
      }
    }
  }
}
</style>
